import { SupportAdminConditionContainer } from "../../containers/SupportSystem/Admin/SupportAdminConditionContainer";
export function SupportAdminConditionPage () {
    return(
       <SupportAdminConditionContainer/>
    )
}